import { src, type Photo } from './catalog';

export function Pic({
  photo,
  alt,
  priority = false,
  className = '',
}: {
  photo: Photo;
  alt: string;
  priority?: boolean;
  className?: string;
}) {
  return (
    <img
      className={className || undefined}
      src={src(photo)}
      alt={alt}
      width={photo.w}
      height={photo.h}
      fetchPriority={priority ? 'high' : undefined}
      loading={priority ? 'eager' : 'lazy'}
      decoding="async"
    />
  );
}
